import { FunctionComponent } from "react";
import "./LightTheme.css";

const LightTheme: FunctionComponent = () => { return null; }

export default LightTheme;